// extracted by mini-css-extract-plugin
export default {"divider_wrapper":"Divider_divider_wrapper__3qmi8","divider":"Divider_divider__56kbu"};